<template>
		<v-card style="border-radius: 15px" class="flex pa-0 round-card background-2" elevation="0">
            <v-card-title class="pa-2 pl-0">
				<p class="pl-2 pl-xl-3">{{ usersLabel ? usersLabel : 'Assegnato a' }}</p>
                <v-spacer></v-spacer>
            </v-card-title>

			<template v-if="users && users.length > 0">
				<v-row class="ma-0">
					<v-col v-for="(user, key, i) in users" :class="fieldClass ? fieldClass : 'col-sm-6 col-md-6 col-lg-6 col-xl-4'" class="px-0 py-1" :key="i">
						<v-list two-line class="background-2 w100p py-0" rounded dense>
							<v-list-item @click="$eventBusUtility.goTo($router, 'users-show', user.value)" style="padding-left: 9px; padding-right: 9px;">
								<v-list-item-avatar style="height: 28px; overflow: inherit;">
									<v-avatar v-if="user.avatar"
										class="custom-avatar"
										:size="52" 
										v-ripple
										style="overflow: inherit"
										:style="{'background-image': 'url(' + user.avatar + ')'}">
									</v-avatar>
									<v-avatar v-else :class="$eventBusUtility.bgColor(user.value)" :size="52">
										<span class="white--text fs22" v-if="user.text">{{ user.text.charAt(0) }}</span>
									</v-avatar>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title>{{ user.text }}</v-list-item-title>
									<v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-col>
				</v-row>
			</template>
			<v-col v-else cols="12" class="col-12 px-0 py-1">
				<v-list class="background-2 w100p py-0">
					<v-list-item>
						<v-list-item-avatar>
							<v-icon color="grey lighten-1" :size="52" >account_circle</v-icon>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title>Nessuno</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-col>
		</v-card>
</template>

<script>

export default {

	name: 'show-users-shared',
	props: {
        id: Number,
		users: Array,
		usersLabel: String,
		fieldClass: String,
	},

	data() {
		return {

		}
	},

	created() {

	}
}
</script>
<style scoped>
    div >>> .v-list-item {
        min-height: 54px;
        min-height: 58px;
        -webkit-user-select: auto;
        user-select: auto;
    }
</style>